import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import { useTheme } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

export const InfoTooltip = ({
  message,
}: {
  message?: string | React.ReactNode;
}) => {
  const theme = useTheme();
  if (!message) return null;
  const tooltipContent =
    typeof message === 'string' && message.includes('\n') ? (
      <>
        {message.split('\n').map((line, i) => (
          <React.Fragment key={i}>
            {i > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </>
    ) : (
      message
    );
  return (
    <Tooltip title={tooltipContent} arrow>
      <InfoOutlinedIcon
        style={{
          fontSize: 16,
          color: theme.palette.text.secondary,
          cursor: 'help',
          marginLeft: 6,
        }}
      />
    </Tooltip>
  );
};
